<template>
  <portlet
      :actionsBlock="true"
      :icon="'fad fa-book'"
      :title="$t('menu.instructions')"
  >
    <div slot="actionsBlock">
      <create-button
          :link="'create-instruction'"
          :text="$t('instructions.createInstruction')"
      />
    </div>
    <template slot="portletBody">
      <div>
        <TabBar @tabClicked="activeKey = $event" :buttons="getTabBarButtons" :defaultSelectedIndex="0"></TabBar>

        <InstructionsByKey v-if="getActiveKey"
                           :isWorkflow="getActiveKey.key==='workflow'"
                           :key-property="getActiveKey.instructionProperty"></InstructionsByKey>

      </div>
    </template>
  </portlet>
</template>
<script>
import InstructionsByKey from "@/views/instructions/InstructionsByKey";
import {mapGetters} from "vuex";
import TabBar from "@/components/TabBar";

export default {
  components: {TabBar, InstructionsByKey},
  mixins: [],
  data() {
    return {
      activeKey: null
    }
  },
  computed: {
    ...mapGetters('company', ['getConfig']),
    getLinkKeysOfCompany() {
      return this.getConfig.instructions ? this.getConfig.instructions.linkKeys : [];
    },
    getActiveKey() {
      return _.find(this.getLinkKeysOfCompany, linkKey => { return linkKey.key === this.activeKey });
    },
    getTabBarButtons() {
      return _.map(_.orderBy(this.getLinkKeysOfCompany, ['priority'], ['asc']), linkKey => {
        return {
          value: linkKey.key,
          label: linkKey.label.translated ? this.$t(linkKey.label.value) : linkKey.label.value
        }
      })
    }
  },
  methods: {},
  watch: {}
}
</script>
<style lang="scss" scoped>
.key-tabs {
  display: grid;
  grid-template-columns: repeat(5, auto);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.key-tab {
  background: #f0f0f0;
  padding: 1rem;
  text-align: center;
  color: darkgrey;
  cursor: pointer;
  border-left: 1px solid #dddddd;
}

.key-tab[active='true'] {
  background: #ecfbff;
  color: #00C9FF;
}

.key-tab:first-child {
  border-radius: 20px 0px 0px 0px;
  border-left: 0px;
}

.key-tab:last-child {
  border-radius: 00px 20px 0px 0px;
}
</style>